export default __webpack_public_path__ + "static/media/mana6.80825332.svg";